import { gql } from '@apollo/client';

export const MINT_AVATAR_MUTATION = gql`
  mutation MintAvatar($data: MintAvatarInput!) {
    mintAvatar(data: $data) {
      enqueued
    }
  }
`;
